import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-sales-insights-list-search',
  standalone: false,
  templateUrl: './sales-insights-list-search.component.html',
  styleUrl: './sales-insights-list-search.component.scss'
})
export class SalesInsightsListSearchComponent {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  onInput(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }
}
